import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { PositionEditorIcon, DivisionsIcon, GeographicalStructure, WorkAndTasksIcon, WorkplacesIcon } from "@icarius-icons/";

const LocationSettingsBox = () => {

  const data = [
    {
      name: getLocalizedString("filterworkplaces"),
      icon: <WorkplacesIcon />,
      path: paths.locationSettings,
    },
    {
      name: getLocalizedString("projectsAndWorks"),
      icon: <WorkAndTasksIcon />,
      path: paths.worksAndTasks,
    },
    {
      name: getLocalizedString("organizationStructure"),
      icon: <PositionEditorIcon />,
      path: paths.organizationStructure,
    },
    {
      name: getLocalizedString("geographicalStructure"),
      icon: <GeographicalStructure />,
      path: paths.geographicalStructure,
    },
    {
      name: getLocalizedString("divisionsSettings"),
      icon: <DivisionsIcon />,
      path: paths.divisionsSettings,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("locationSettingsBox")}
      data={data}
    />
  );
}

export default LocationSettingsBox;
